export const SEO_SITE_NAME = 'Chocowi';
export const SEO_SITE_URL = process.env.REACT_APP_SITE_URL || 'https://chocowi.com';
export const SEO_DEFAULT_TITLE = 'Chocowi';
export const SEO_DEFAULT_DESCRIPTION = 'Chocowi is a marketplace for sweets, gifts, services, and wholesale sourcing. Discover trusted sellers, verified suppliers, and curated listings in one place.';
export const SEO_DEFAULT_IMAGE = `${SEO_SITE_URL}/chocowi-logo.png`;

export const buildTitle = (title) => (title ? `${title} | ${SEO_SITE_NAME}` : SEO_DEFAULT_TITLE);
